var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetaLeftCinza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.005,
    height: 16.539,
    viewBox: "0 0 11.005 16.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seta-left-cinza",
    transform: "translate(0.5 0.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429",
    d: "M10.8,291.965a1.1,1.1,0,0,1,.726,1.954L4.775,299.7l6.752,5.782a1.1,1.1,0,1,1-1.433,1.67l-7.73-6.614a1.1,1.1,0,0,1,0-1.679l7.73-6.62a1.1,1.1,0,0,1,.707-.278Z",
    transform: "translate(-1.976 -291.965)",
    fill: "#c8cacc",
    stroke: "#c8cacc",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaLeftCinza);
export default __webpack_public_path__ + "static/media/seta-left-cinza.4290f7211eaca8b1da20d55b2a3e0af8.svg";
export { ForwardRef as ReactComponent };